// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sandPit = defineModel({
  id: "sand-pit",
  batchId: "future",
  name: "Sand pit",
  tags: ["scenery","sand","pit","low-poly","age-of-mcp","future"],
  summary: "A pit of building sand. Melts into glass, binds mortar, forms casting moulds and scours as abrasive.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.44, 0.46, 0.06, 12), color: "#c4a868", position: [0, 0.03, 0] },
      { geometry: new THREE.CylinderGeometry(0.34, 0.4, 0.05, 12), color: "#dcc486", position: [0, 0.08, 0] },
      { geometry: new THREE.ConeGeometry(0.2, 0.2, 9), color: "#e8d59c", position: [0.06, 0.18, -0.02] },
      { geometry: new THREE.ConeGeometry(0.12, 0.12, 8), color: "#dcc486", position: [-0.16, 0.12, 0.12] },
      { geometry: new THREE.BoxGeometry(0.02, 0.26, 0.05), color: "#7a5a32", position: [0.1, 0.24, -0.02], rotation: [0.5, 0, 0.2] },
    ],
  animations: [],
});
